<div class="body">
    <br/>
    <div class = "container principal">
        <div class = "col-lg-12"> 
          <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben conservar los originales de los documentos </b>
           <br/>
           <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b>
           <br/>
           <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b>  Dictamen N° 467/2021. 
           <br/>   
           <br/>   
           La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual 
           <br/>
           conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario  administrativo.   
          <br/>  
             </p>    
             <p><b>Manual de subsidio de matrimonio: </b> <a href="{{this.linkTexto}}" target="_blank">
                Matrimonio</a>.</p>        
        </div>
    </div>
    <br/>
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Subsidio Matrimonio </h1>
        </div>

        <div class="col-lg-4"> </div>

    </div>
    <br/>

    <form #matrimonioForm=ngForm>

        <div class="container principal">
            <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

                <div class="row">

                    <div class="col-lg-8"> </div>

                    <div class="col-lg-4">
                        <p> <b> Usuario: </b> {{nombreUsuario}} </p>
                    </div>

                </div>

            </div>



            <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

                <div class="row">

                    <div class="col-lg-1"> </div>

                    <div class="col-lg-2">
                        <h2> Rut Afiliado </h2>
                    </div>
                 
                    <div class="col-lg-4">

                        <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado"
                            #rutAfiliado="ngModel" class="form-control" type="text" required
                            placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                            pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>

                    <div class="col-lg-1"> </div>

                    <div class="col-lg-1">
            
                        <button class="btn btn-primary" id="btnvalida"
                        (click)="buscaRegistroCivil(buscador.rutAfiliado,3)" [disabled]="rutAfiliado.invalid">
                             Buscar
                        </button>

                    </div>

                    <div class="col-lg-1"> </div>

                </div>
                <div class="row">

                    <div class="col-lg-5"> </div>
               
                    <div class="col-lg-5">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>
                    </div>

                </div>
            </div>
            <br/>
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h3> Datos Cónyuge </h3>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <label> RUT Cónyuge </label>
                </div>
                <div class="col-lg-5">
                 
                    <input id="rutConyuge" name="rutConyuge" [(ngModel)]="matrimonio.rutConyuge" #rutConyuge="ngModel"
                    class="form-control" type="text" required type="text" value="15314204-1"
                    placeholder="Ingrese el RUT del conyuge. Ej: 11111111-1"
                    pattern="[0-9]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>
                <div class="col-lg-3">
                
                    <button class="btn btn-info" (click)="buscarHijo(matrimonio.rutConyuge)">
                        Consultar
                    </button>


                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <label> Nombre Cónyuge </label>
                </div>
                <div class="col-lg-5">

                   <input id="nombreConyugue" name="nombreConyugue" #nombreConyugue="ngModel" [(ngModel)]="matrimonio.nombreConyugue"
                    class="form-control" required type="text" />


                </div>
                <div class="col-lg-3">

                </div>
            </div>
            <br/>
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h3> Datos Unión </h3>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <label> Tipo Union </label>
                </div>

                <div class="col-lg-5">
                   
                    <mat-select class="form-control" name="tipoUnion" #tipoUnion="ngModel"
                    [(ngModel)]="matrimonio.tipoUnion" required>

                    <mat-option value="0">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let tipo of this.tipos" value="{{tipo.id}}">
                        {{tipo.descripcion}}
                    </mat-option>
                </mat-select>   

                </div>

                <div class="col-lg-3"> </div>

            </div>

            <br/>

            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Fecha Celebración</p>
                </div>

                <div class="col-lg-5">
                    <input class="form-control" id="fechaUnion" name="fechaUnion" #fechaUnion="ngModel"
                    [(ngModel)]="matrimonio.fechaUnion" required type="date">

                </div>

                <div class="col-lg-3"> </div>

            </div>

            <div class="row">
              
                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar </p>
                </div>
    
                <div class="col-lg-5">
    
                    <input type="file" class="form-control-file" name="archivo" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="matrimonio.archivoTest"
                        (change)="seleccionaArchivo($event, 0)">
    
                </div>
    
                <div class="col-lg-1"> </div>
    
                <div class="col-lg-1">  </div>
    
                <div class="col-lg-1"> </div>
                

            </div>
            <br/>
            <div class="row line">

                <div class="col-lg-2 col-sm-2"> </div>

                <div class="col-lg-6 col-sm-1"> </div>

                <div class="col-lg-3 col-sm-1">
                    <!--<div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">-->    
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_CONTABILIDAD' && rol != 'ROLE_ENCARGADO_CONTABILIDAD'">
                        <button class="btn btn-success " (click)="solicitar(matrimonioForm)">
                            Solicitar
                        </button>
                    </div>
                </div>

                <div class="col-lg-1 col-sm-1"> </div>

            </div>

            <!--/form-->

        </div>
    </form>
    <div class="container" style="height:100px"> </div>
</div>